import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-catalogo-obras-inversionistas-grupos',
  templateUrl: './catalogo-obras-inversionistas-grupos.component.html',
  styleUrls: ['./catalogo-obras-inversionistas-grupos.component.scss']
})
export class CatalogoObrasInversionistasGruposComponent implements OnInit {

  @Input() public grupo: any;
  @Output() public deleteGroup: EventEmitter<number> = new EventEmitter;
  @Output() public setError: EventEmitter<string> = new EventEmitter;
  error: any;
  constructor() { }

  ngOnInit() {
  }
  delete() {
    this.deleteGroup.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-grupos/catalogo-obras-inversionistas-grupos.component.ts